import { TransactionDateType, TransactionState } from 'types/dto';

// Possible types of a query parameter value
type QueryParamValue = string | boolean | number | null | undefined | Date;

// An object representing URL query parameters
export type QueryParams = Record<string, QueryParamValue | Array<QueryParamValue>>;

// Current request status
export enum RequestStatus {
  Creating = 'creating',
  Error = 'error',
  None = 'none',
  Reading = 'reading',
  Success = 'success',
  Updating = 'updating',
}

export interface EntityUpdatePayload<TData> {
  data: TData;
  id: string;
}

export type PaginatedListRequestQuery = {
  ItemsPerPage?: number;
  PageNumber?: number;
};

export type PaginatedTransactionListRequestQuery = PaginatedListRequestQuery & {
  BankAccountIds?: Array<string>;
  DateType?: TransactionDateType;
  MappingState?: TransactionState;
  MaxTransactionDate?: string;
  MinTransactionDate?: string;
};
